if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {
	/*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

	document.addEventListener("DOMContentLoaded", () => {
		window.location.hash && animateTo(window.location.hash.substring(1));
	});

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	$('.sym-slides').slick({
		accessibility: true,
	});

	if(document.querySelector('.form-module-wrapper._microsite-form')){
		document.querySelector('.header__cta.js-scroll-form').classList.remove('hidden');
	}else{
		document.querySelector('.header__cta.js-scroll-form').classList.add('hidden');
	}

	//CTA Header - Scroll down to the bottom form
	if (document.querySelector('.js-scroll-form')) {
		document.querySelectorAll('.js-scroll-form').forEach((btn, i) => {
			btn.addEventListener('click', (_) => {
				let top_ele = $('#content > section._microsite-form').offset().top;
				$('html,body')
					.animate({ scrollTop: top_ele - 100 }, 2000)
					.delay(1200);
			});
			// if (i === 0) btn.click();
		});
	}

	// slider hero home
	$('.hero-slides').slick({
		accessibility: true,
		fade: false,
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 500,
		pauseOnFocus: false,
		pauseOnHover: false,
		arrows: false,
		dots: false,
		centerMode: true,
		centerPadding: '195px',
		slidesToShow: 1,
		responsive: [
			{
				breakpoint: 1551,
				settings: {
					centerPadding: '80px',
				},
			},
			{
				breakpoint: 1393,
				settings: {
					centerPadding: '20px',
				},
			},
			{
				breakpoint: 601,
				settings: {
					centerPadding: '10px',
				},
			},
		],
	});

	// Slider Block
	$('.slider-block_list').slick({
		accessibility: true,
		dots: true,
		fade: true,
		autoplay: false,
		autoplaySpeed: 5000,
		speed: 500,
		pauseOnFocus: false,
		pauseOnHover: false,
		appendDots: $('.slider-dots-box'),
		dotsClass: 'slider-dots',
		responsive: [
			{
				breakpoint: 901,
				settings: {
					arrows: false,
					adaptiveHeight: false,
					fade: true,
					dots: true,
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	// slider bg content
	$('.sym-slides-reviews').slick({
		arrows: false,
		dots: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 6000,
		speed: 700,
		fade: true,
		accessibility: true,
		arrows: true,
		appendDots: $('.slider-dots-boxT'),
		dotsClass: 'slider-dotsT',
	});

	// On before slide change
	$('.sym-slides-reviews')
		.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			$('.slider-dots-boxT button').html('');
		})
		.trigger('beforeChange');

	// On before slide change
	$('.sym-slides-reviews')
		.on('afterChange', function (event, slick, currentSlide) {
			$('.slider-dots-boxT button').html('');
			$('.slider-dots-boxT .slick-active button').html(`<svg class="progress-svg" width="26" height="26">
        <g transform="translate(13,13)">
          <circle class="circle-go" r="12" cx="0" cy="0"></circle>
        </g>
        </svg>`);
		})
		.trigger('afterChange');

	// On before slide change
	$('.slider-block_list')
		.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			$('.slider-dots-box button').html('');
		})
		.trigger('beforeChange');

	// On before slide change
	$('.slider-block_list')
		.on('afterChange', function (event, slick, currentSlide) {
			$('.slider-dots-box button').html('');
			$('.slider-dots-box .slick-active button').html(`<svg class="progress-svg" width="26" height="26">
        <g transform="translate(13,13)">
          <circle class="circle-go" r="12" cx="0" cy="0"></circle>
        </g>
        </svg>`);
		})
		.trigger('afterChange');
})();

function animateTo(target) {
	const toTarget = document.getElementById(target);

	if (!toTarget)
		return;

	const headerRects = (document.getElementById("header") || document.getElementsByTagName("header")[0]).getBoundingClientRect();
    const from = window.scrollY;
    const to = toTarget.getBoundingClientRect().top + from - (headerRects.height + headerRects.top);
    const duration = 1300;
    const start = performance.now();

	const easeInOutQuart = t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;

    function step(timestamp) {
        const time = timestamp - start;
        const progress = Math.min(time / duration, 1);
        const yH = easeInOutQuart(progress) * (to - from) + from;

        window.scrollTo(0, yH);

		time < duration && requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
}
